<template>
    <el-drawer  title="模型详情"
                :visible.sync="isShow"
                direction="rtl"
                custom-class="custom-drawer"
                size="700"
                :modal="false"
                :modal-append-to-body="false" v-if="model">
        <div class="drawer-body">
            <div class="sub-title">{{model.name}}</div>
            <div class="main">
                <service-item v-for="(item, index) in model.serves" :key="model.id + index" :item="item" :is-edit-mode="false"></service-item>
            </div>
        </div>
    </el-drawer>
</template>

<script>
    import serviceItem from "./serviceItem";
    export default {
        name: "modalDrawer",
        components: {
            serviceItem
        },
        data() {
            return {
                isShow: false,
                model: null,
            }
        },
        methods: {
            show(data) {
                this.model = data;
                this.isShow = true;
            }
        }
    }
</script>

<style scoped>
    .sub-title{
        padding: 0 30px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 600;
        line-height: 26px;
        margin-bottom: 22px;
        width: 700px;
    }

    .main{
        padding-left: 30px;
        padding-right: 30px;
        box-sizing: border-box;

    }
    .drawer-body{
        height: 100%;
        overflow-y: auto;
    }

</style>

<style>
    .custom-drawer .el-drawer__header{
        margin-bottom: 15px!important;
    }

    .el-drawer__body{
        overflow: hidden;
    }
</style>